import React from 'react';
import { Box, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { useFormField } from './FormFieldContext';

export const FormFieldMessage: React.FC = () => {
  const { isMessage, message, isWarning, isError } = useFormField();

  if (isError || isWarning || !isMessage || !message) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <WarningIcon color="warning" sx={{ mr: 1, fontSize: 20 }} />
      <Typography color="warning.main" variant="caption">
        {message}
      </Typography>
    </Box>
  );
};
